/* eslint-disable no-use-before-define */
import { ajax } from '../../../twd/twd';

let lastStates = {}
var lastAjaxAbort
export const getTooltipData = async ({state}) => {

    try {
        if (lastAjaxAbort) {
            lastAjaxAbort()
            lastAjaxAbort = null
        }

        const last = lastStates[state]
        if (last && (Date.now() - last.ts)<60000) {
            return {...last.data}
        }

        delete lastStates[state]

        let {data, abort} = await ajax({
            url: '/esb/retailservice/marketSnapshotService/getMuniMapToolTipData',
            method: 'POST',
            params: {
                marketSnapshotsType: 'MUNI_MAP_DATA',
                state
            }
        })

        lastAjaxAbort = abort
        let info = (((await data) || {}).states || {})[state] || {state}
        lastAjaxAbort = null

        lastStates[state] = { ts:Date.now(), data:info }

        return info
    } catch(e) {
        return undefined
    }
}



// WEBPACK FOOTER //
// ./src/municipals/map/tooltip/get-tooltip-data.js